<template>
  <div
    v-if="showLoadingState < 1"
    key="loadingState"
    class="m-initial-loading"
  >
    <AtomLoadingPrimary/>
  </div>
  <div
    v-else-if="$modal.element.suscripcion"
    class="m-card-primary m-the-modal-content"
  >
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="$modal.closeModal"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionBillingMyShoppingModalPendingPayMethodsChange.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <p class="font-weight-bold text-color-danger margin-top-xsmall">
          {{ $t('mEditionBillingMyShoppingModalPendingPayMethodsChange.warningParagraph') }}
        </p>
        <p  v-if="$modal.element.suscripcion">
          <span :class="iconClass">
            <i class="fas fa-history"></i>
          </span>
          <span>
            {{ $t('mEditionBillingMyShoppingModalPendingPayMethodsChange.subscription.statePaymentChange.title') }}
            <span class="font-weight-bold text-color-warning">
              {{ $t('mEditionBillingMyShoppingModalPendingPayMethodsChange.subscription.statePaymentChange.state') }}
            </span>
            <span v-if="$modal.element.suscripcion.estado_fecha">
              {{ $t('mEditionBillingMyShoppingModalPendingPayMethodsChange.subscription.statePaymentChange.to') }}
              {{ $moment.parseZone($modal.element.suscripcion.estado_fecha).format('D MMMM, YYYY') }}
            </span>
          </span>
        </p>
        <p>
          <span :class="iconClass">
            <i class="fas fa-receipt"></i>
          </span>
          <span>
            {{$modal.element.compra.concepto_compra}}
          </span>
        </p>
        <p v-if="$modal.element.suscripcion.precio">
          <span :class="iconClass">
            <i class="far fa-credit-card"></i>
          </span>
          <span>
            {{ $t('mEditionBillingMyShoppingModalPendingPayMethodsChange.subscription.plan') }}
            <span class="font-weight-bold">
              {{ getPaymentFrequency($modal.element.suscripcion.pago_cuotas, $modal.element.suscripcion.pago_frecuencia, $modal.element.suscripcion.pago_intervalo) }}
              {{ $modal.element.suscripcion.divisa }}
              {{ $modal.element.suscripcion.precio.toFixed(2) }}
            </span>
              <span class="text-color-black-35">
                {{ $modal.element.suscripcion.divisa_iso_code }}
              </span>
            </span>
        </p>
        <p v-if="$modal.element.suscripcion.medio_pago">
          <span :class="iconClass">
            <i class="far fa-credit-card"></i>
          </span>
          <span>
            {{ $t('mEditionBillingMyShoppingModalPendingPayMethodsChange.subscription.method') }}
            <span class="font-weight-bold">
              {{ $modal.element.suscripcion.medio_pago }}
            </span>
          </span>
        </p>
        <p v-if="$modal.element.suscripcion.id_externo">
          <span :class="iconClass">
            <i class="fas fa-key"></i>
          </span>
          <span>{{ $t('mEditionBillingMyShoppingModalPendingPayMethodsChange.subscription.idExternal') }} {{ $modal.element.suscripcion.medio_pago }}
            <i class="text-color-black-65">
              {{ $modal.element.suscripcion.id_externo }}
            </i>
          </span>
        </p>
        <p v-if="($modal.element.compra.detalle && compra.compra.detalle.cuponCodigo) && compra.compra.precio !== undefined">
          <span :class="iconClass">
            <i class="fas fa-percentage"></i>
          </span>
          <span>
            {{ $t('mEditionBillingMyShoppingModalPendingPayMethodsChange.discount.line1') }}
            {{ compra.compra.detalle.cuponCodigo }}
            {{ $t('mEditionBillingMyShoppingModalPendingPayMethodsChange.discount.line2') }}
            {{ compra.compra.detalle.cuponMontoDescuento }}%
          </span>
        </p>
        <p v-if="$modal.element.suscripcion.fecha_inicio || $modal.element.suscripcion.fecha_proximo_pago">
          <span :class="iconClass">
            <i class="fas fa-calendar-day"></i>
          </span>
          <span>
            {{ $t('mEditionBillingMyShoppingModalPendingPayMethodsChange.subscription.paymentNext') }}
            <span
              v-if="$modal.element.suscripcion.fecha_inicio && $moment.parseZone().isBefore($moment.parseZone($modal.element.suscripcion.fecha_inicio))"
              :style="proxPagoClass"
            >
              {{ $moment.parseZone($modal.element.suscripcion.fecha_inicio).format('D MMMM, YYYY') }}
            </span>
            <span
              v-else
              :style="proxPagoClass"
            >
              {{ $moment.parseZone($modal.element.suscripcion.fecha_proximo_pago).format('D MMMM, YYYY') }}
            </span>
          </span>
        </p>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingMyShoppingModalPendingPayMethodsChange',

  data () {
    return {
      buttonPrimary: {
        action: 'Entendido',
        class: '',
        sending: false,
        type: 'submit'
      },
      iconClass: '',
      proxPagoClass: '',
      showLoadingState: 0
    }
  },

  computed: {
    academyDataColor () {
      return this.$store.getters.getAcademyData.color
    }
  },

  created () {
    if (this.academyDataColor) {
      this.buttonPrimary.class = 'a-button-academy-primary'
      this.iconClass = 'info-icon-left info-icon-academy'
      this.proxPagoClass = 'border-bottom: 1px dashed var(--color-brand-academy-primary);'
    } else {
      this.buttonPrimary.class = 'a-button-billing-primary'
      this.iconClass = 'info-icon-left info-icon-billing'
      this.proxPagoClass = 'border-bottom: 1px dashed var(--color-brand-billing-primary);'
    }
    setTimeout(() => {
      this.showLoadingState++
    }, 500)
  },
  methods: {
    getPaymentFrequency (cuotas, frecuencia, intervalo) {
      return cuotas === 1
        ? '1 pago de'
        : cuotas === 0
          ? `1 pago cada ${intervalo || 1} ${this.$filters.getFrequencyValue(frecuencia, 'name')}`
          : `${cuotas} cuotas mensuales`
    }
  }
}
</script>
